import React from 'react';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import SaleBanner from '../../../../banners/SaleBanner';
import { useCurrentPromo } from '../../../../utils/hooks/useCurrentPromo';
export function useSaleBannerItem() {
    const currentPromo = useCurrentPromo('self');
    return !!currentPromo && {
        key: 'sale-banner',
        label: /*#__PURE__*/ React.createElement(SaleBanner, {
            isNarrow: true,
            endDate: currentPromo.endDate,
            discountValuePercent: currentPromo.discountValuePercent,
            referralType: ReferralType.PROMOTION_BANNER_USERMENU
        })
    };
}
